"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ZendeskController;
var _useTheme = _interopRequireDefault(require("@mui/material/styles/useTheme.js"));
var _react = _interopRequireWildcard(require("react"));
var _Help = _interopRequireDefault(require("../icons/Help"));
var _MenuIcon = _interopRequireDefault(require("./MenuIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const zendeskKey = '91749650-ab9a-4dc7-93a4-76b6f89bb517';
/** Zendesk wrapper component using MenuIcon */
function ZendeskController({
  open: parentOpen,
  iconProps,
  buttonProps,
  userAlias,
  settings,
  onOpen,
  onClose
}) {
  const {
    palette
  } = (0, _useTheme.default)();
  const [open, setOpen] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (parentOpen != null) toggleOpen(parentOpen);
  }, [parentOpen]);
  const _settings = {
    webWidget: {
      color: {
        theme: palette.primary.main
      },
      launcherText: palette.primary.contrastText,
      position: {
        horizontal: 'right',
        vertical: 'top'
      },
      offset: {
        horizontal: '28px',
        vertical: '49px'
      },
      ...(settings && settings)
    }
  };
  (0, _react.useEffect)(() => {
    if (process.env.NODE_ENV !== 'production') return;
    const script = document.createElement('script');
    script.async = true;
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    script.onload = function () {
      window.zE('webWidget', 'hide');
      userAlias && window.zE('webWidget', 'prefill', {
        name: {
          value: userAlias
        }
      });
      window.zE('webWidget:on', 'open', () => {
        window.zE('webWidget', 'show');
        onOpen && onOpen();
        if (parentOpen == null) {
          setOpen(true);
        }
      });
      window.zE('webWidget:on', 'close', () => {
        window.zE('webWidget', 'hide');
        onClose && onClose();
        if (parentOpen == null) {
          setOpen(false);
        }
      });
      window.zESettings = _settings;
    };
    document.body.appendChild(script);
    return () => {
      delete window.zE;
      delete window.zESettings;
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (!window.zE) return;
    window.zE('webWidget', 'updateSettings', _settings);
  }, [palette]);
  const toggleOpen = open => {
    if (!window.zE) return;
    if (!open) window.zE('webWidget', 'close');else window.zE('webWidget', 'open');
  };
  if (process.env.NODE_ENV !== 'production') return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuIcon.default, {
    open: open,
    onClick: () => toggleOpen(!open),
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Help.default, {
      ...iconProps
    }),
    buttonProps: buttonProps,
    tooltip: "Get help",
    popoverProps: {
      PaperProps: {
        sx: {
          overflow: 'auto'
        }
      }
    },
    noPadding: true
  });
}